/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_DescriptionInputs */

const en_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to insert music note symbols into your text`)
};

const fr_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez comment insérer les symboles de notes de musique dans votre texte`)
};

const de_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie aus, wie Musiknotensymbole in Ihren Text eingefügt werden sollen.`)
};

const it_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli come inserire i simboli delle note musicali nel tuo testo`)
};

const ru_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите способ вставки символов музыкальных нот в текст.`)
};

const es_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige cómo insertar símbolos de notas musicales en tu texto`)
};

const zh_cn2_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择如何在文本中插入音符符号`)
};

const ja_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストに音符記号を挿入する方法を選択します`)
};

const hi_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने टेक्स्ट में संगीत नोट प्रतीकों को कैसे शामिल करना है, यह चुनें।`)
};

const pt_pt2_music_notes_description = /** @type {(inputs: Music_Notes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha como inserir símbolos de notas musicais no seu texto.`)
};

/**
* | output |
* | --- |
* | "Choose how to insert music note symbols into your text" |
*
* @param {Music_Notes_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_description = /** @type {((inputs?: Music_Notes_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_music_notes_description(inputs)
	if (locale === "de") return de_music_notes_description(inputs)
	if (locale === "it") return it_music_notes_description(inputs)
	if (locale === "ru") return ru_music_notes_description(inputs)
	if (locale === "es") return es_music_notes_description(inputs)
	if (locale === "zh-CN") return zh_cn2_music_notes_description(inputs)
	if (locale === "ja") return ja_music_notes_description(inputs)
	if (locale === "hi") return hi_music_notes_description(inputs)
	if (locale === "pt-PT") return pt_pt2_music_notes_description(inputs)
	return en_music_notes_description(inputs)
});